module.exports = __webpack_public_path__ + "img/9788983717269.70f0a1bd.jpg";